import { handleActions } from 'redux-actions'
import * as type from './type'
import { LOCATION_CHANGE } from 'connected-react-router'

export const initialState = {
    anamnesisList: {},
    fetching: false,
    error: null,
    showAnamnesis: false,
    isEditingTreatmentExpectation: false,
    isInfoLegendShown: false,
}

export default handleActions(
    {
        [LOCATION_CHANGE]: (state, action) => {
            return {
                ...initialState,
            }
        },
        [type.FIND_OR_CREATE_ANAMNESIS_REQUEST]: (state, action) => {
            return {
                ...state,
                error: null,
                fetching: true,
            }
        },
        [type.FIND_OR_CREATE_ANAMNESIS_SUCCESS]: (state, action) => {
            const { anamnesis } = action.payload
            return {
                ...state,
                fetching: false,
                anamnesisList: {
                    ...state.anamnesisList,
                    [anamnesis.templateKey]: anamnesis,
                },
            }
        },
        [type.FIND_OR_CREATE_ANAMNESIS_ERROR]: (state, action) => {
            const { error } = action.payload
            return {
                ...state,
                fetching: false,
                error,
            }
        },
        [type.CHANGE_ANAMNESIS]: (state, action) => {
            const { name, value, templateKey } = action.payload

            return {
                ...state,
                anamnesisList: {
                    ...state.anamnesisList,
                    [templateKey]: {
                        ...state.anamnesisList[templateKey],
                        [name]: value,
                    },
                },
            }
        },
        [type.UPDATE_ANAMNESIS]: (state, action) => {
            const { anamnesis, templateKey } = action.payload
            return {
                ...state,
                anamnesisList: {
                    ...state.anamnesisList,
                    [templateKey]: {
                        ...state.anamnesisList[templateKey],
                        formData: anamnesis
                    },
                },
            }
        },
        [type.SAVE_ANAMNESIS_REQUEST]: (state, action) => {
            return {
                ...state,
                error: null,
                fetching: true,
            }
        },
        [type.SAVE_ANAMNESIS_SUCCESS]: (state, action) => {
            const { anamnesis } = action.payload
            return {
                ...state,
                fetching: false,
                anamnesisList: {
                    ...state.anamnesisList,
                    [anamnesis.templateKey]: anamnesis,
                },
            }
        },
        [type.SAVE_ANAMNESIS_ERROR]: (state, action) => {
            const { error } = action.payload
            return {
                ...state,
                fetching: false,
                error,
            }
        },
        [type.TOGGLE_ANAMNESIS]: (state, action) => {
            return {
                ...state,
                showAnamnesis: !state.showAnamnesis,
            }
        },
        [type.TOGGLE_EDITING_TREATMENT_EXPECTATION]: (state, action) => {
            return {
                ...state,
                isEditingTreatmentExpectation: !state.isEditingTreatmentExpectation,
            }
        },
        [type.TOGGLE_INFO_LEGEND]: (state, action) => {
            return {
                ...state,
                isInfoLegendShown: !state.isInfoLegendShown,
            }
        },
    },
    initialState
)



// WEBPACK FOOTER //
// ./src/modules/anamnesis/state/anamnesis/reducer.js